/* eslint-disable import/no-named-as-default */
/* eslint-disable import/no-named-as-default-member */
import React, { Fragment } from 'react';
import _ from 'lodash';
import { Route, Redirect, Switch, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { MobileHeader } from './common/components/Header';
import Aside from './common/components/Theme/Aside';
import Content from './common/components/Theme/Content';
import Loader from './common/components/Loader';
import LoginResponse from './views/login-response';
import Users from './views/users';
import User from './views/user';
import PendingDeletion from './views/pendingDeletion';
import PurgedUsers from './views/purgedUsers';
import AdminsList from './views/admins';
import PurgedUser from './views/purgedUsers/PurgedUser';
import Features from './views/features';
import ErrorPage from './views/404page';
import Events from './views/events';
import { validateToken } from './services/auth';
import CreateEvent from './views/create-event/CreateEvent';
import Event from './views/event';

const AsideWithRouter = withRouter(props => <Aside {...props} />);
const ContentWithRouter = withRouter(props => <Content {...props} />);
const loginUrl = __CONFIG__.loginRedirectUrl;

class RedirectPage extends React.Component {
  componentDidMount() {
    window.location.replace(loginUrl);
  }

  render() {
    return <Fragment />;
  }
}

const mapStateToProps = state => ({
  isAdmin: state.loginReducer.isAdmin,
});

const mapStateToPrivateRouteProps = state => ({
  accessToken: state.loginReducer.accessToken,
});

const PrivateRoute = ({ component: Component, accessToken, ...rest }) => (
  <Route
    {...rest}
    render={props =>
        (validateToken(accessToken) ? <Component {...props} /> : <RedirectPage />)
      }
  />
);

const ConnectedPrivateRoute = connect(mapStateToPrivateRouteProps)(PrivateRoute);

const AdminRoute = ({ component: Component, isAdmin, ...rest }) => (
  <ConnectedPrivateRoute
    {...rest}
    component={props => (
      <Loader isLoading={_.isUndefined(isAdmin)}>
        {isAdmin ? (
          <Component {...props} />
          ) : (
            <Redirect to="/" />
          )}
      </Loader>
      )}
  />
);

const ConnectedAdminRoute = connect(mapStateToProps)(AdminRoute);

module.exports = (
  <div className="kt-grid kt-grid--hor kt-grid--root">
    <MobileHeader />
    <div className="kt-grid__item kt-grid__item--fluid kt-grid kt-grid--ver kt-page">
      <AsideWithRouter />
      <ContentWithRouter>
        <Switch>
          <Route exact path="/login-response" component={LoginResponse} />
          <ConnectedPrivateRoute exact path="/" component={Users} />
          <ConnectedPrivateRoute exact path="/users" component={Users} />
          <ConnectedPrivateRoute exact path="/users/:id" component={User} />
          <ConnectedPrivateRoute
            exact
            path="/pending-deletion"
            component={PendingDeletion}
          />
          <ConnectedPrivateRoute
            exact
            path="/pending-deletion/:id"
            component={User}
          />
          <ConnectedAdminRoute
            exact
            path="/purged-users"
            component={PurgedUsers}
          />
          <ConnectedAdminRoute
            exact
            path="/purged-users/:userDbId"
            component={PurgedUser}
          />
          <ConnectedPrivateRoute
            exact
            path="/features"
            component={Features}
          />
          <ConnectedAdminRoute
            exact
            path="/admins"
            component={AdminsList}
          />
          <ConnectedAdminRoute
            exact
            path="/events/create"
            component={CreateEvent}
          />
          <ConnectedAdminRoute
            exact
            path="/events/:id"
            component={Event}
          />
          <ConnectedAdminRoute
            exact
            path="/events"
            component={Events}
          />
          <ConnectedPrivateRoute component={ErrorPage} />
        </Switch>
      </ContentWithRouter>
    </div>
  </div>
);



// WEBPACK FOOTER //
// ./src/js/routes.jsx